var main = require('@/main')
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App)
app.config.globalProperties.$http = main.Axios
app.config.globalProperties.$formatDate = (date, locales_id, time_zone, is_utc = false) => {
    if (is_utc) {
        return main.timezone.tz(main.timezone.utc(date), time_zone).locale(locales_id).format('L LTS')
    }
    return main.timezone(date).format('YYYY-MM-DD HH:mm:ss')
}
app.config.globalProperties.$formatAmount = (locales_id, amount, currency) => {
    amount = ( amount / 100 ).toFixed(2)
    var formatter = new Intl.NumberFormat(locales_id, {
        style: 'currency',
        currency
    })
    return formatter.format(amount)
}
app.config.globalProperties.$formatTransactionType = (type) => {
    switch (type) {
        case 1:
            type = 'Debit'
            break;
        default:
            type = 'N/A'
            break;
    }
    return type
}

app.use(main.i18n)
app.use(router)
app.use(main.store)
app.use(main.VCalendar)
app.use(main.VueReCaptcha, {
    siteKey: main.config.recaptcha.site_key
})
app.mount('#app')